module.exports = "/packs/images/homepage/whatson/learn_to_swim_desktop~985d5fdd1116a976c4b1e5de82f02f9d.jpg";